import { render } from "./CasesByExecutor.vue?vue&type=template&id=387a01a3"
import script from "./CasesByExecutor.vue?vue&type=script&lang=js"
export * from "./CasesByExecutor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__